<template>
  <div class="yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)] bg-gray-50">
    <!-- 导航栏 -->
    <navBar :title="$t('orderDetail.title')" :showBack="true"></navBar>

    <div class="px-4 py-4 space-y-4 detail">
      <div :class="['bg-white rounded-lg px-4 py-2 text-left text-lg font-bold flex items-center ', getStatusClass]">
        {{ getStatusText }}
      </div>
      <!-- 商品信息 -->
      <div class="bg-white rounded-lg overflow-hidden">
        <div class="flex items-center px-4 py-2 border-b border-gray-100">
          <div class="w-2 h-4 bg-orange-500 mr-2"></div>
          <span class="text-gray-800 font-medium">{{ $t("orderDetail.productInfo") }}</span>
        </div>
        <div
          v-for="(item, index) in orderDetail.items"
          :key="index"
          class="flex items-center px-4 py-2 border-b border-gray-100"
          :class="index === orderDetail.items.length - 1 ? 'border-b-0' : ''">
          <img :src="imageBaseUrl + item.picUrl" alt="" class="w-12 h-12 rounded-lg" />
          <div class="ml-3 flex-1">
            <div class="flex items-center justify-between">
              <span>{{ item.spuType }} {{ isZh ? item.spuPlace : item.spuPlaceEn }}</span>
              <span>RM {{ formatToYuan(item.price) }}</span>
            </div>
            <div class="flex items-center justify-between">
              <span class="mr-1">
                {{
                  isZh
                    ? item.dayValue.name + $t("products.day") + "&nbsp;" + item.packageValue.name
                    : item.dayValue.nameEn +
                      (item.dayValue.nameEn > 1 ? $t("products.days") : $t("products.day")) +
                      "&nbsp;" +
                      item.packageValue.nameEn
                }}
              </span>
              <span>x{{ item.count }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 订单金额 -->
      <div class="bg-white rounded-lg overflow-hidden">
        <div class="flex items-center px-4 py-2 border-b border-gray-100">
          <div class="w-2 h-4 bg-orange-500 mr-2"></div>
          <span class="text-gray-800 font-medium">{{ $t("orderDetail.orderAmount") }}</span>
        </div>
        <van-cell :title="$t('orderDetail.shippingFee')" :value="`RM ${formatToYuan(orderDetail.deliveryPrice)}`" />
        <van-cell :title="$t('orderDetail.productAmount')" :value="`RM ${formatToYuan(orderDetail.totalPrice)}`" />
        <van-cell
          :title="$t('orderDetail.yoyoCoinDiscount')"
          :value="`-RM ${formatToYuan(orderDetail.pointPrice)}`"
          value-class="text-[#ff7a00]" />
        <van-cell
          :title="$t('orderDetail.couponDiscount')"
          :value="`-RM ${formatToYuan(orderDetail.couponPrice)}`"
          value-class="text-[#ff7a00]" />
        <van-cell
          :title="$t('orderDetail.actualAmount')"
          :value="`RM ${formatToYuan(orderDetail.payPrice)}`"
          title-class="font-medium"
          value-class="text-[#ff7a00] font-medium text-lg" />
      </div>

      <!-- 收货信息 -->
      <div class="bg-white rounded-lg overflow-hidden">
        <div class="flex items-center px-4 py-2 border-b border-gray-100">
          <div class="w-2 h-4 bg-orange-500 mr-2"></div>
          <span class="text-gray-800 font-medium">{{ $t("orderDetail.receiverInfo") }}</span>
        </div>

        <div v-if="showReceiverInfo">
          <van-cell :title="$t('orderDetail.receiverName')" :value="orderDetail.receiverName" />
          <van-cell :title="$t('orderDetail.receiverPhone')" :value="orderDetail.receiverMobile" />
          <van-cell
            :title="$t('orderDetail.receiverAddress')"
            :value="orderDetail.receiverCity + '' + orderDetail.receiverCountry + '' + orderDetail.receiverDetailAddress" />
        </div>
        <van-cell :title="$t('orderDetail.email')" :value="orderDetail.email" />
      </div>

      <!-- 物流信息 -->
      <div
        class="bg-white rounded-lg overflow-hidden"
        v-if="orderDetail.logisticsName || orderDetail.logisticsNo || orderDetail.deliveryTime">
        <div class="flex items-center px-4 py-2 border-b border-gray-100">
          <div class="w-2 h-4 bg-orange-500 mr-2"></div>
          <span class="text-gray-800 font-medium">{{ $t("orderDetail.logisticsInfo") }}</span>
        </div>

        <van-cell :title="$t('orderDetail.logisticsCompany')" :value="orderDetail.logisticsName" />
        <van-cell :title="$t('orderDetail.trackingNumber')" :value="orderDetail.logisticsNo" />
        <van-cell :title="$t('orderDetail.shippingTime')" :value="orderDetail.deliveryTime" />
      </div>

      <!-- 订单信息 -->
      <div class="bg-white rounded-lg overflow-hidden">
        <div class="flex items-center px-4 py-2 border-b border-gray-100">
          <div class="w-2 h-4 bg-orange-500 mr-2"></div>
          <span class="text-gray-800 font-medium">{{ $t("orderDetail.orderInfo") }}</span>
        </div>

        <van-cell :title="$t('orderDetail.orderNumber')" :value="orderDetail.id" />
        <van-cell :title="$t('orderDetail.serialNumber')" :value="orderDetail.no" />
        <van-cell :title="$t('orderDetail.createTime')" :value="formatTime(orderDetail.createTime)" />
        <van-cell v-if="orderDetail.payTime" :title="$t('orderDetail.payTime')" :value="formatTime(orderDetail.payTime)" />
      </div>
    </div>

    <div v-if="orderDetail.status == 0"  class="flex flex-col justify-center items-center">
      <PaymentMethod ref="paymentMethod" />
      <van-button type="danger" class="w-44 h-9 rounded-xl mt-4 mb-10" color="#ff7a00" @click="handlePay"> 
        {{ $t("orderDetail.rePay") }}
      </van-button>
    </div>


  </div>
</template>

<script>
import PaymentMethod from "@/components/products/PaymentMethodNew.vue"
import dayjs from "dayjs"
import { Cell, CellGroup, Toast } from "vant"
import { getOrderDetail } from "@/apis/order"
import { mapGetters } from "vuex"
import { formatToYuan } from "@/utils/common"

export default {
  name: "OrderDetail",
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    PaymentMethod,
  },
  data() {
    return {
      orderDetail: {},
      formatToYuan,
      showReceiverInfo: false,
    }
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
    }),
    imageBaseUrl() {
      return process.env.VUE_APP_IMAGE_URL
    },
    getStatusText() {
      // 0 待支付 10 待发货 20 待收货 30 已完成 40 已取消
      const status = this.orderDetail.status
      const statusMap = {
        0: this.$t("orders.statusProcessing"),
        10: this.$t("orders.statusPending"),
        20: this.$t("orders.statusShipped"),
        30: this.$t("orders.statusDelivered"),
        40: this.$t("orders.statusCancelled"),
      }
      // console.log("status :>> ", statusMap[status])
      return statusMap[status] || status
    },

    getStatusClass() {
      // 0 待支付 10 待发货 20 待收货 30 已完成 40 已取消
      const status = this.orderDetail.status
      const statusClassMap = {
        0: "text-[#ff7a00]",
        10: "text-blue-500",
        20: "text-green-500",
        30: "text-green-500",
        40: "text-red-500",
      }
      return statusClassMap[status] || "text-gray-500"
    },
  },
  created() {
    // 获取路由参数中的订单ID
    const orderId = this.$route.query.orderId
    const orderNo = this.$route.query.orderNo
    if (orderId || orderNo) {
      this.getOrderDetail(orderId, orderNo)
    }
  },
  methods: {
    formatTime(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss")
    },
    async getOrderDetail(orderId, orderNo) {
      try {
        // 这里应该调用API获取订单详情
        const res = await getOrderDetail({ id: orderId, orderNo: orderNo })
        this.orderDetail = res.data
        console.log("this.orderDetail :>> ", this.orderDetail)
        const items = this.orderDetail.items
        items.forEach((item) => {
          if (item.spuType === "SIM") {
            this.showReceiverInfo = true
          }
        })
        console.log("获取订单详情:", orderId)
      } catch (error) {

      }
    },
    handlePay() {
      if (!this.$refs.paymentMethod.validatePayment()) {
        Toast(this.$t("products.completePaymentInfo"))
        return
      }
      Toast.loading({
        forbidClick: true,
        overlay: true,
        duration: 60000,
      })

      // 获取支付数据
      const paymentData = this.$refs.paymentMethod.getPaymentData()
      console.log("paymentData :>> ", paymentData)
      // console.log('payParams :>> ', this.orderDetail.payParams);
      this.createAndClickPayButton(this.orderDetail.payParams, paymentData.channel)
    },
    createAndClickPayButton(payParams, channel) {
      try {
        console.log("payParams :>> ", payParams)
        const { amount, billDesc, billEmail, billMobile, billName, currency, merchantID, orderId, vscode } = payParams || {}

        // 移除已存在的按钮（避免重复）
        const existingButton = document.getElementById("molpay-button")
        if (existingButton) {
          existingButton.remove()
        }

        // 创建新的支付按钮
        const button = document.createElement("button")
        button.id = "molpay-button"
        button.style.display = "none" // 不显示在页面上

        // 设置所有必需的属性
        button.setAttribute("data-toggle", "molpayseamless")
        button.setAttribute("data-mpschannel", channel)
        button.setAttribute("data-mpsamount", amount)
        button.setAttribute("data-mpsbill_desc", billDesc || "buy goods")
        button.setAttribute("data-mpsbill_email", billEmail || "")
        button.setAttribute("data-mpsbill_mobile", billMobile || "")
        button.setAttribute("data-mpsbill_name", billName || "")
        button.setAttribute("data-mpscurrency", currency)
        button.setAttribute("data-mpsmerchantid", merchantID)
        button.setAttribute("data-mpsorderid", orderId)
        button.setAttribute("data-mpsvcode", vscode)

        // button.setAttribute("data-mpsreturnurl", "https://www.yoyotravel.my/pay-success")

        // 添加到 body
        document.body.appendChild(button)

        // 调试：检查属性是否正确设置
        console.log("创建的按钮属性:", {
          name: button.getAttribute("data-mpsbill_name"),
          desc: button.getAttribute("data-mpsbill_desc"),
          email: button.getAttribute("data-mpsbill_email"),
          mobile: button.getAttribute("data-mpsbill_mobile"),
          vcode: button.getAttribute("data-mpsvcode"),
          orderId: button.getAttribute("data-mpsorderid"),
          merchantID: button.getAttribute("data-mpsmerchantid"),
          currency: button.getAttribute("data-mpscurrency"),
          amount: button.getAttribute("data-mpsamount"),
          channel: button.getAttribute("data-mpschannel"),
        })
        // return
        // 触发点击
        this.$nextTick(() => {
          try {
            button.click()
            console.log("支付按钮已触发")

            // 点击后可以移除按钮
            setTimeout(() => {
              button.remove()
              Toast.clear()
            }, 1000)
          } catch (error) {
            Toast.clear()
            console.error("触发支付失败:", error)
          }
        })
      } catch (error) {
        Toast.clear()
        console.log("error :>> ", error)
      }
    },
  },
}
</script>

<style scoped>
/* 自定义样式 */
/deep/.detail .van-cell {
  background-color: transparent;
  padding: 0.25rem 1rem;
}
/deep/ .detail .van-cell::after {
  border-bottom: none;
}
</style>
